import type { ReactNode } from "react";
import { AlertCircle, CheckCircle2, LoaderCircle, X } from "lucide-react";

export function Loading({ label = "Loading" }: { label?: string }) {
  return <div className="loading" role="status"><LoaderCircle className="spin" size={22} /> {label}…</div>;
}

export function EmptyState({ title, children }: { title: string; children: ReactNode }) {
  return <div className="empty-state"><div className="empty-icon"><CheckCircle2 size={22} /></div><h3>{title}</h3><p>{children}</p></div>;
}

export function Notice({ children, kind = "error", onDismiss }: { children: ReactNode; kind?: "error" | "success"; onDismiss?: () => void }) {
  return <div className={`notice ${kind}`} role={kind === "error" ? "alert" : "status"}>{kind === "error" ? <AlertCircle size={18} /> : <CheckCircle2 size={18} />}<span>{children}</span>{onDismiss && <button aria-label="Dismiss" onClick={onDismiss}><X size={16} /></button>}</div>;
}

export function StatusPill({ value }: { value: string }) {
  return <span className={`status-pill status-${value.replaceAll("_", "-")}`}>{value.replaceAll("_", " ")}</span>;
}

export function formatDate(value?: string | null) {
  if (!value) return "Not scheduled";
  return new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", year: "numeric" }).format(new Date(`${value.slice(0, 10)}T12:00:00`));
}

export function formatBytes(value: number) {
  if (value < 1024) return `${value} B`;
  if (value < 1024 ** 2) return `${Math.round(value / 1024)} KB`;
  return `${(value / 1024 ** 2).toFixed(1)} MB`;
}
